// eslint-disable-next-line import/prefer-default-export
export const EZDINE = 'ezdine';
export const PUNCHH = 'punchh';

export const PUNCHH_TYPE = {
    'REDEEMABLE': 'redeem',
    'REDEEMABLE_FULL': 'redeemable',
    'DEALS': 'deals'
}